<!--
 * @Author: zhonghao
 * @Date: 2023-12-18 16:25:28
-->
<template>
  <div>
    <img src="../../../assets/images/questionBank/img(12).png" @click.stop="handleClickDel" class="del-img"
      v-if="typeTxt === 'errDisease' || typeTxt === 'delIcon'" alt="">
    <img src="../../../assets/images/questionBank/img(8).png" @click.stop="handleClickCol" class="del-img"
      v-if="typeTxt === 'colDisease' || typeTxt === 'colIcon'" alt="">
    <div class="tag">LV{{ dataProps && dataProps.difficultyLevel }}</div>
    <img src="../../../assets/images/questionBank/iconLock.png" v-if="dataProps.unlockStatus+'' === '2'" class="item-cover" alt="">
    <img src="../../../assets/images/questionBank/img(14).png" v-else class="item-cover" alt="">
    <div class="item-title2" v-if="typeTxt === 'errDisease' || typeTxt === 'colDisease'">{{ dataProps && dataProps.questionNum }}题</div>
    <div class="item-title" v-if="typeTxt === 'delIcon' || typeTxt === 'colIcon'">{{ dataProps && dataProps.questionNumber }}</div>
    <div class="item-title" v-else>{{ dataProps && dataProps.className }}</div>
    <template v-if="typeTxt === 'subject'">
      <div class="item-txt1" :class="dataProps.answerStatus + '' === '1' ? 'col1' : ''"
        v-if="dataProps.answerStatus + '' === '1'">未通过</div>
      <div class="item-txt1" v-if="dataProps.answerStatus + '' === '2'">未答题</div>
      <div class="item-txt1" :class="dataProps.answerStatus + '' === '3' ? 'col2' : ''"
        v-if="dataProps.answerStatus + '' === '3'">已通过</div>
    </template>
    <template v-else-if="typeTxt === 'errDisease' || typeTxt === 'colDisease' || typeTxt === 'colIcon'"></template>
    <template v-else-if="typeTxt === 'delIcon'">
      <div class="item-txt1 col1">
        已做错{{ dataProps.errorNum }}次
      </div>
    </template>
    <template v-else-if="`${dataProps.unlockStatus}` === '1'">
      <div class="item-txt1 item-txt2">正确率{{ dataProps.accuracy }}</div>
      <div class="item-txt1">{{ dataProps.answerTime }}</div>
    </template>
    <template v-if="`${dataProps.unlockStatus}` === '2' && `${dataProps.unlockMethod}` === '1'">
      <div class="item-txt1 item-unlock">答题或{{dataProps.unlockCost}}积分解锁</div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    dataProps: {},
    typeTxt: ''
  },
  data () {
    return {

    }
  },
  methods: {
    handleClickDel () {
      this.$emit('handleDel')
    },
    handleClickCol () {
      this.$emit('handleCol')
    },
  }
}
</script>
<style lang="less" scoped>
.del-img {
  position: absolute;
  top: 6px;
  left: 9px;
  width: 16px;
  display: block;
}

.tag {
  font-size: 12px;
  color: rgba(0, 0, 0, .6);
  width: 30px;
  height: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  position: absolute;
  top: 8px;
  background-color: rgba(0, 0, 0, 0.04);
  right: 8px;
}

.item-cover {
  margin-top: 36px;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-bottom: 14px;
}

.item-title {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  text-align: center;
  line-height: 20px;
  margin-bottom: 23px;
  min-height: 20px;
}
.item-title2 {
  color: #6A7481;
  text-align: center;
  font-size: 13px;
  margin-bottom: 12px;
}

.item-txt1 {
  color: #6A7481;
  line-height: 18px;
  height: 18px;
  text-align: right;
  font-weight: 400;
  font-size: 10px;
  position: absolute;
  width: 100%;
  left: 0;
  padding: 0 8px;
  box-sizing: border-box;
  bottom: 4px;
  &.item-txt2 {
    bottom: 22px;
  }

  &.col1 {
    color: #EB5753;
  }

  &.col2 {
    color: #328714;
  }
  &.item-unlock {
    color: #EB1700;
    font-size: 11px;
    line-height: 20px;
    height: 20px;
  }
}</style>



// WEBPACK FOOTER //
// src/views/questionBank/components/items.vue